var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaybackActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6219 14.1542C17.9049 14.3487 18.1948 14.3626 18.4919 14.1959C18.789 14.0292 18.9375 13.7792 18.9375 13.4459L18.9375 6.57091C18.9375 6.23757 18.789 5.99091 18.4919 5.83091C18.1948 5.67146 17.9049 5.68202 17.6219 5.86257L12.3597 9.32091C12.1051 9.48757 11.9777 9.71674 11.9777 10.0084C11.9777 10.3001 12.1051 10.5292 12.3597 10.6959L17.6219 14.1542ZM9.13443 14.1542C9.41735 14.3487 9.70734 14.3626 10.0044 14.1959C10.3015 14.0292 10.45 13.7792 10.45 13.4459L10.45 6.57091C10.45 6.23757 10.3015 5.99091 10.0044 5.83091C9.70734 5.67146 9.41735 5.68202 9.13443 5.86257L3.87218 9.32091C3.61755 9.48757 3.49024 9.71674 3.49024 10.0084C3.49024 10.3001 3.61755 10.5292 3.87218 10.6959L9.13443 14.1542Z",
    fill: "#8F4300",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaybackActive);
export default __webpack_public_path__ + "static/media/Playback_active.432e4e59dd647da9f92b60e15f067070.svg";
export { ForwardRef as ReactComponent };